<template>
  <div class="coq-modal">
    <div class="coq-modal__top-right">
      <a @click="$emit('close')">
        <font-awesome-icon icon="times" type="fas" size="lg"/>
      </a>
    </div>

    <h3>Modifier mon adresse</h3>
    <p>Vous pouvez ici modifier votre adresse postale.</p>
    <br/>

    <address-form-v2 :address="address" ref="address"/>

    <div class="coq-modal__footer">
      <b-button disabled variant="primary" style="width: 100%">
        <template v-if="loading">
          <font-awesome-icon icon="spinner" spin/>
        </template>
        <template v-else>
          Confirmer la modification
        </template>
      </b-button>
    </div>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import AddressFormV2 from '../Utilisateurs/Utilisateur_Formulaire_Adresse';
  import _ from 'lodash';

  export default {
    name: 'MemberEditAddressModal',
    components: { AddressFormV2 },
    data() {
      return {
        address: {
          street: '',
          app: '',
          city: '',
          province: '',
          country: '',
          postal_code: ''
        },
        loading: false
      };
    },
    beforeMount() {
      if (this.userInfos.address) {
        this.address = _.cloneDeep(this.userInfos.address);
      }
    },
    computed: {
      ...mapState({
        userInfos: state => state.account.user.infos
      })
    },
    methods: {
      ...mapActions('account', {
        _updateAddress: 'updateAddress'
      }),
      async updateAddress() {
        // Validate form
        this.$refs.address.$v.$touch();
        if (this.$refs.address.$v.$anyError) {
          return;
        }

        // Do the update
        if (!this.loading) {
          this.loading = true;
          try {
            await this._updateAddress(this.address);
            this.$emit('close');
            this.$swal.fire({
              text: 'L\'adresse postale a été mise à jour',
              type: 'success',
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            });
          }
          finally {
            this.loading = false;
          }
        }
      }
    }
  };
</script>

<style scoped>

</style>
